var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layer-list-container" },
    [
      _c(
        "div",
        { staticClass: "data-panel" },
        [
          _c(
            "b-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "b-col",
                { staticClass: "layer-list-font", attrs: { cols: "12" } },
                [_vm._v("Road Features")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layers" },
        [
          _c(
            "draggable",
            [
              _c(
                "transition-group",
                { attrs: { type: "transition", name: "flip-list" } },
                _vm._l(_vm.drtLayersButtonsCtrl, function (element, index) {
                  return _c(
                    "b-row",
                    {
                      key: element.name,
                      staticClass: "layer-row",
                      class: _vm.getLayerClass(index, element),
                      attrs: { id: element.name },
                    },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "layer-btn",
                          class: _vm.getLayerClass(index, element),
                          attrs: { cols: "8" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleLayer(element, $event)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "layer-row-label" }, [
                            _vm._v(
                              _vm._s(
                                element.display_name
                                  ? element.display_name
                                  : element.name
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "layer-arrow layer-arrow--end",
                          attrs: { cols: "4" },
                        },
                        [
                          _c("fa", {
                            staticClass: "cursor",
                            attrs: {
                              title: "Move Layer To Top",
                              icon: ["fas", "long-arrow-alt-up"],
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toTopOfList(
                                  element.display_name
                                    ? element.display_name
                                    : element.name
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.layerLegend
        ? _c("AI_LayerLegend", {
            staticClass: "layer-legend-position p-1",
            attrs: {
              id: "layerLegend",
              layerLegendMaxHeight: _vm.layerLegendMaxHeight,
              layerLegendName: _vm.layerLegendName,
              legendImgSrc: _vm.legendImgSrc,
              legendMinimized: _vm.layerLegendMinimized,
            },
            on: {
              closeLegend: function ($event) {
                return _vm.closeLegend()
              },
              maximizeLegend: function ($event) {
                return _vm.maxOrMinLegend(false)
              },
              minimizeLegend: function ($event) {
                return _vm.maxOrMinLegend(true)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }